import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel } from '@chakra-ui/react';

import Tip from '@/components/Tip/Tip';
import IRootPageLink from '@/types/IRootPageLink';
import { Button, Heading } from '@chakra-ui/react';
import AddLinkModal from './components/AddLinkModal/AddLink.modal';
import AccordionLink from './components/accordion-link/AccordionLink';
import { useSectionLinks } from './section-links.controller';

interface IProps {
	isLoading: boolean;
	links: Array<IRootPageLink>;
	onChange: (v: { links: Array<IRootPageLink> }) => Promise<void>;
}

export default function SectionLinks(props: IProps) {
	const { t, isOpen, onOpen, onClose, handleLinkChange, handleLinkDelete, handleAddLink } = useSectionLinks(props);

	return (
		<>
			<Accordion allowToggle mt="2" background="white" borderRadius="md" borderColor="gray.100" borderWidth={1}>
				<AccordionItem overflow="hidden" borderRadius="md" border="none">
					<AccordionButton>
						<Heading size="sm" as="h5" p="4">
							{t('Links')}
						</Heading>
						<AccordionIcon ml="auto" />
					</AccordionButton>
					<AccordionPanel pb={4} borderTopWidth={1} borderTopColor="gray.100" borderTopStyle="solid">
						<Tip>
							{t(
								'Add links to your reservation calendars, products or webpages. You can customize the visible text and description'
							)}
						</Tip>

						<Accordion allowToggle>
							{props.links.map((link, index) => {
								return (
									<AccordionLink
										key={index}
										link={link}
										onChange={(value) => handleLinkChange(index, value)}
										onDelete={() => handleLinkDelete(index)}
										isLoading={props.isLoading}
									/>
								);
							})}
						</Accordion>

						<Button colorScheme="primary" mt="4" w="100%" onClick={onOpen} isLoading={props.isLoading}>
							{t('Add new link')}
						</Button>
					</AccordionPanel>
				</AccordionItem>
			</Accordion>
			<AddLinkModal close={onClose} isOpen={isOpen} onLinkAdded={handleAddLink} />
		</>
	);
}
